import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/pro-solid-svg-icons';

import LoadingSpinner from 'components/loading_spinner';

import DuplicatesPageHeader from './duplicates_page_header';
import DuplicatesPageTopbar from './duplicates_page_topbar';
import DuplicatesTable from './duplicates_table';
import SvnHowToLink from '../svn_how_to_link';

import { getDuplicatePeopleCount, isLoading } from '../../store/selectors/duplicates';
import DuplicatesPagination from 'bundles/contact/index/people/duplicates/duplicates_pagination';

export class DuplicateContactsView extends React.Component {
  static propTypes = {
    isLoading: PropTypes.bool,
    totalCount: PropTypes.number.isRequired
  };

  render() {
    return (
      <React.Fragment>
        <DuplicatesPageHeader />
        <DuplicatesPageTopbar />
        {this.renderResults()}
      </React.Fragment>
    );
  }

  renderResults() {
    const { isLoading, totalCount } = this.props;

    if (isLoading) return <LoadingSpinner />;
    if (totalCount > 0) return this.renderTable();
    return this.renderEmptyState();
  }

  renderEmptyState() {
    return (
      <div className="no-results-panel" name="no-results-panel">
        <FontAwesomeIcon className="text-muted my-4" icon={faSearch} size="5x" />
        <h4 className="mt-4">
          <strong className="text-lg">No duplicate contacts found</strong>
        </h4>
        <SvnHowToLink className="mt-4" />
      </div>
    );
  }

  renderTable() {
    return (
      <React.Fragment>
        <DuplicatesTable />
        <DuplicatesPagination />
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  isLoading: isLoading(state),
  totalCount: getDuplicatePeopleCount(state)
});

export default connect(mapStateToProps)(DuplicateContactsView);
